import type { ProcessedCareerLayerData } from '@/application/careerLayer/filterCareerLayerByJornadaUseCase';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type {
  CareerLayerStoreEntity,
  CareerLayerStoreRepository,
} from '../models';

const defaultCareerLayerState: CareerLayerStoreEntity = {
  apiData: null,
  specificFilters: { jornada: null },
  valueHeader: null,
  isLoading: false,
};

export const useCareerLayerStore = create<CareerLayerStoreRepository>()(
  persist(
    (set, get) => ({
      ...defaultCareerLayerState,

      loadData: (apiResponse: ProcessedCareerLayerData) => {
        const { apiData } = get();
        if (JSON.stringify(apiData) === JSON.stringify(apiResponse)) return;

        set({
          apiData: apiResponse,
          isLoading: false,
        });
      },

      setSpecificFilters: (filters) => {
        set((state) => ({
          specificFilters: { ...state.specificFilters, ...filters },
        }));
      },

      setValueHeader: (valueHeader) => {
        set({ valueHeader });
      },

      setLoading: (loading: boolean) => set({ isLoading: loading }),

      clearData: () => set({ ...defaultCareerLayerState }),
    }),
    {
      name: '@app/career-layer',
      partialize: (state: CareerLayerStoreRepository) => ({
        specificFilters: state.specificFilters,
        valueHeader: state.valueHeader,
      }),
    },
  ),
);
